/* erzeugt aus preview/ (shop-port.js) */
/* OTHERSPORTS · Interaktive Trainingswelt (Demo)
   Ronny 30.10.2026: Der Player ist immer derselbe – eine Einheit aus drei Übungen in fester Reihenfolge.
   Die Reiter Core/Balance/Fitness wechseln nur die Beschreibung rechts, das iPad bleibt unberührt.
   Loops: nahtlos geschnitten aus den Animationen „16 Bulgarischer Ausfallschritt2“, „04 Bird-Dog mit Band“,
   „19 Balance Glute Bridge mit Band“ (960×720, weißer Grund). Seit 31.10.2026 stabilisiert: die Quellen „atmen“
   (Kamera zoomt langsam, der Schnitt holt es zurück, bei Bird Dog 3,9 %). Maßstab und Lage sind herausgerechnet, Bezug
   ist Bild 0, das zugleich das Vorschaubild ist.
   rate = Abspieltempo, damit eine Wiederholung gut 4–5 s dauert (wie im Trainings-Player).
   Wiederholungen und Technik-Hinweise stammen aus dem Core-Plan (Level 3, Einheiten B und C). Die Demo läuft bewusst
   nur EINEN Satz je Übung, damit man schnell durchkommt (Ronny 31.10.2026). */
(function () {
  'use strict';
  var root = document.querySelector('[data-os-tw]');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var el = function (tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

  var UEBUNGEN = [
    { phase: 'Kraftaufbau', name: 'Bulgarischer Ausfallschritt', dosis: '1 × 8 pro Seite · Medium- oder Heavy-Band', rate: 0.9,
      src: window.OS_NEU_ASSET('tw-loop-bulgarisch.mp4'),
      tipps: ['Vorderer Fuß steht stabil auf dem Board, der hintere liegt erhöht ab.', 'Oberkörper aufrecht, das Band hältst du seitlich am Körper.', 'Senk das hintere Knie langsam Richtung Boden.'] },
    { phase: 'Stabilität', name: 'Bird Dog', dosis: '1 × 8 pro Seite · Arm + Bein, Medium- oder Heavy-Band', rate: 0.75,
      src: window.OS_NEU_ASSET('tw-loop-birddog.mp4'),
      tipps: ['Vierfüßlerstand, Hände unter den Schultern, Knie unter den Hüften.', 'Streck gegenüberliegenden Arm und Bein lang aus.', 'Halte das Becken waagerecht, kurze Pause in der Streckung.'] },
    { phase: 'Kraftaufbau', name: 'Glute Bridge', dosis: '1 × 10 · mit Halbrolle und Band', rate: 0.75,
      src: window.OS_NEU_ASSET('tw-loop-bridge.mp4'),
      tipps: ['Rückenlage, Füße auf der Halbrolle, Band über der Hüfte.', 'Heb das Becken gegen den Bandzug bis zur geraden Linie.', 'Becken waagerecht halten, Gesäß oben fest anspannen.'] }
  ];

  /* Nur diese Angaben ändern sich beim Reiterwechsel */
  var PROGRAMME = {
    core: { produkt: 'Sportboard 4 Core', titel: 'Rumpf systematisch stärken', punkte: ['Rumpf und unteren Rücken gezielt kräftigen', 'Geführte Einheiten à ca. 20 Minuten', 'Dein Level-Check zeigt, wann du steigerst'], fakten: ['12 Wochen', '3 Levels', '3 × 20 Min'], url: '/pages/core-training-rumpf', cta: 'Core-Training ansehen' },
    balance: { produkt: 'Sportboard 4 Balance', titel: 'Sicherer stehen und gehen', punkte: ['Gleichgewicht und sicheren Stand trainieren', 'Vom festen Stand Schritt für Schritt aufs Board', 'Klare Kriterien für den nächsten Level'], fakten: ['12 Wochen', '3 Levels', '3 × 20 Min'], url: '/pages/balance-training-gleichgewicht-trittsicherheit', cta: 'Balance-Training ansehen' },
    fitness: { produkt: 'Sportboard 4 Fitness', titel: 'Kraft und Muskulatur aufbauen', punkte: ['Kraft und Muskeln am ganzen Körper aufbauen', 'Widerstand über drei Bandstärken steigern', '20 oder 40 Minuten – passend zu deinem Tag'], fakten: ['3 Programme', '3 Levels', '20 / 40 Min'], url: '/pages/fitness-training-muskelaufbau-zuhause', cta: 'Fitness-Training ansehen' }
  };

  var state = { program: 'core', step: 0, started: false };
  var clips = [];

  function current() { return UEBUNGEN[state.step]; }
  function istLetzte() { return state.step === UEBUNGEN.length - 1; }
  function weiterText() { return istLetzte() ? 'Einheit abschließen  →' : 'Nächste Übung  →'; }
  function track(name, payload) { if (window.osTrack) window.osTrack(name, payload); }

  /* ---- Gerät: gleiche Größe in jedem Schritt, nach jedem Wechsel ganz im Bild ----
     Mobil hat das Gerät eine feste Entwurfsgröße (--tw-dw × --tw-dh in der CSS); seine Breite rechnet die CSS aus Bildschirmbreite
     und kleinster Bildschirmhöhe, hier kommt nur der Faktor für den Inhalt dazu. Am Desktop steht das iPad ohnehin fest (dark.js). */
  var buehne = $('[data-tw-scene]'), shell = $('.os-tw__shell');
  function skaliere() {
    if (!buehne || !shell) return;
    var dw = parseFloat(getComputedStyle(buehne).getPropertyValue('--tw-dw'));
    if (dw) shell.style.setProperty('--tw-ms', (buehne.clientWidth / dw).toFixed(4));
  }
  /* Liegt das Gerät nicht komplett unter der festen Kopfzeile im Bild, wird es dorthin gescrollt (mittig in der freien Fläche). */
  function anker() {
    var g = buehne || shell;
    if (!g) return;
    var kopf = document.getElementById('os-header'), oben = kopf ? kopf.getBoundingClientRect().bottom : 0;
    var r = g.getBoundingClientRect(), hoehe = window.innerHeight;
    if (r.top >= oben && r.bottom <= hoehe) return;
    var ruhig = document.documentElement.classList.contains('no-motion') || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var ziel = window.scrollY + r.top - oben - Math.max(0, (hoehe - oben - r.height) / 2);
    window.scrollTo({ top: Math.round(ziel), behavior: ruhig ? 'instant' : 'smooth' });
  }

  /* ---- Bewegungsablauf: je Übung ein eigenes Videoelement, das beim ersten Start einmal lädt.
          So gibt es beim Übungswechsel kein leeres Bild und keine doppelten Anfragen auf dieselbe Datei. ---- */
  function clip(i) {
    if (clips[i]) return clips[i];
    var x = UEBUNGEN[i], v = el('video', 'os-tw__video'), bild = $('[data-tw-ex="' + i + '"] img');
    v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto'; v.hidden = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.width = 960; v.height = 720;
    if (bild) v.poster = bild.currentSrc || bild.src;
    v.defaultPlaybackRate = x.rate;
    v.src = x.src;
    $('[data-tw="motion"]').appendChild(v);
    clips[i] = v;
    return v;
  }
  function stopMotion() { clips.forEach(function (v) { if (v) { v.pause(); v.hidden = true; } }); }
  function renderMotion() {
    stopMotion();
    var v = clip(state.step);
    UEBUNGEN.forEach(function (x, i) { clip(i); });
    v.hidden = false;
    v.playbackRate = UEBUNGEN[state.step].rate;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* ---- Beschreibung rechts ------------------------------------------------- */
  function syncBar() {
    var bar = document.querySelector('.os-twinfo'), p = PROGRAMME[state.program];
    if (!bar) return;
    bar.querySelector('[data-tw-bar="title"]').textContent = p.titel;
    bar.querySelector('[data-tw-bar="produkt"]').textContent = p.produkt;
    var punkte = bar.querySelector('[data-tw-bar="punkte"]');
    punkte.replaceChildren();
    p.punkte.forEach(function (t) { punkte.appendChild(el('li', null, t)); });
    var facts = bar.querySelector('[data-tw-bar="facts"]');
    facts.replaceChildren();
    p.fakten.forEach(function (f) { facts.appendChild(el('li', null, f)); });
    var cta = document.querySelector('[data-tw-bar="cta"]');
    cta.textContent = p.cta;
    cta.href = p.url;
  }

  /* ---- Geführte Einheit ---------------------------------------------------- */
  function renderStep() {
    var x = current();
    $('[data-tw="phase"]').textContent = x.phase;
    $('[data-tw="exercise"]').textContent = x.name;
    $('[data-tw="dose"]').textContent = x.dosis;
    $('[data-tw="count"]').textContent = 'Übung ' + (state.step + 1) + ' von ' + UEBUNGEN.length;
    $('[data-tw="player-bar"]').style.width = ((state.step + 1) / UEBUNGEN.length * 100) + '%';
    $('[data-tw="instruction"]').textContent = 'Schau dir die Bewegung an, trainiere deinen Satz und hake ihn ab.';
    $('[data-tw-action="go"]').textContent = 'Satz geschafft  ✓';
    $('[data-tw-action="next"]').textContent = weiterText();
    var tips = $('[data-tw="tips"]');
    tips.replaceChildren();
    x.tipps.forEach(function (t) { tips.appendChild(el('li', null, t)); });
    $('[data-tw="ring-value"]').textContent = '0/1';
    $('[data-tw="ring-unit"]').textContent = 'Satz';
    renderMotion();
  }

  function show(name) {
    ['dash', 'player', 'done'].forEach(function (n) { $('[data-tw="' + n + '"]').hidden = n !== name; });
    $('[data-tw="status"]').textContent = { dash: 'Deine Einheit', player: 'Geführte Einheit', done: 'Geschafft' }[name];
    anker();
  }

  function showPlayer(startAt) {
    state.step = startAt || 0;
    state.started = true;
    show('player');
    renderStep();
    track('tw_start', { programm: state.program });
  }

  function showDash() {
    stopMotion();
    show('dash');
    $('[data-tw-action="start"]').classList.toggle('os-tw__btn--pulse', !state.started);
    $('[data-tw="coach"]').hidden = state.started;
  }

  function finish() {
    stopMotion();
    show('done');
    track('tw_finish', { programm: state.program });
  }

  function weiter() {
    if (istLetzte()) { finish(); return; }
    state.step += 1;
    renderStep();
    anker();
  }

  /* ---- Ereignisse ------------------------------------------------------------ */
  $$('[data-tw-program]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      state.program = tab.getAttribute('data-tw-program');
      $$('[data-tw-program]').forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
      track('tab_training', { tab: state.program });
      syncBar();
    });
  });
  $$('[data-tw-ex]').forEach(function (b) {
    b.addEventListener('click', function () { showPlayer(Number(b.getAttribute('data-tw-ex'))); });
  });
  $('[data-tw-action="start"]').addEventListener('click', function () { showPlayer(0); });
  $('[data-tw="coach"]').addEventListener('click', function () { showPlayer(0); });
  $$('[data-tw-action="back"]').forEach(function (b) { b.addEventListener('click', showDash); });
  /* Ein Satz je Übung: „Satz geschafft“ führt ohne Zwischenschritt zur nächsten Übung bzw. zum Abschluss */
  $('[data-tw-action="go"]').addEventListener('click', weiter);
  $('[data-tw-action="next"]').addEventListener('click', weiter);
  var dialog = $('[data-tw="dialog"]');
  $('[data-tw-action="technique"]').addEventListener('click', function () { if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); });
  $('[data-tw-action="close"]').addEventListener('click', function () { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  $('[data-tw-action="start"]').classList.add('os-tw__btn--pulse');
  skaliere();
  window.addEventListener('resize', skaliere);
  if ('ResizeObserver' in window && buehne) new ResizeObserver(skaliere).observe(buehne);
  root.setAttribute('data-ready', 'true');
})();
